import Vue from 'vue'
const S3 = require('aws-sdk/clients/s3')
const SecretsManager = require('aws-sdk/clients/secretsmanager')
const AWS = require('aws-sdk/global')

const albumBucketName = 'relief-evidence'
const bucketRegion = 'us-east-2'
const IdentityPoolId = 'us-east-2:12dd9d32-19fc-4315-930a-97924c657a8c'

AWS.config.update({
  region: bucketRegion,
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId,
  }),
})

const s3Client = new S3({
  apiVersion: '2006-03-01',
  params: { Bucket: albumBucketName },
})

Vue.prototype.$s3 = s3Client

const secretsmanager = new SecretsManager({ apiVersion: '2017-10-17' })
Vue.prototype.$secretsmanager = secretsmanager
